import { Component } from '@angular/core';

@Component({
  templateUrl: 'reporequest.component.html'
})
export class ReporequestComponent {

  constructor() { 

  } 
}


// WEBPACK FOOTER //
// ./src/app/repoagencies/reporequest.component.ts